import React from "react";

//assets
import show from "assets/svg/showPassword.svg";
import UsePasswordToggle from "hooks/UsePasswordToggle";
import eyeSlash from "assets/svg/eye-slash.svg";

interface AuthInputProps {
  name?: string;
  type?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  customRef?: React.RefObject<HTMLInputElement>;
  isPassword?: boolean;
  placeholder?: string;
  defaultValue?: string;
  value?: string;
  className?: string;
  disabled?: boolean;
  autoComplete?: string;
  pattern?: string;
}

export default function AuthInput({
  name,
  type,
  onChange,
  customRef,
  isPassword,
  placeholder,
  defaultValue,
  value,
  className = "",
  disabled,
  autoComplete,
  pattern,
}: AuthInputProps) {
  //hook
  const { showPassword, togglePassword } = UsePasswordToggle();

  let inputType: string;

  if (isPassword && showPassword) {
    inputType = "text";
  } else if (isPassword && !showPassword) {
    inputType = "password";
  } else {
    inputType = type || "text";
  }

  return (
    <div className="mt-2 rounded-lg text-gray700 bg-gray30 relative overflow-hidden">
      <input
        ref={customRef}
        name={name}
        type={inputType}
        disabled={disabled}
        placeholder={placeholder}
        defaultValue={defaultValue}
        value={value}
        className={` ${className} ${
          isPassword ? "pr-[50px]" : "pr-5"
        }  w-full outline-none bg-inherit border-none placeholder:text-sm py-3 pl-5 text-sm placeholder:text-[#5E5E5E]`}
        onChange={onChange}
        autoComplete={autoComplete}
        pattern={pattern}
      />

      {isPassword && (
        <div className="cursor-pointer w-[20px] bg-none absolute top-[50%] -translate-y-[50%] right-5">
          <img
            src={showPassword ? eyeSlash : show}
            alt="toggle password"
            onClick={togglePassword}
            className="cursor-pointer"
          />
        </div>
      )}
    </div>
  );
}
